export const M4_HR = () : React.JSX.Element => {
    return(
        <>
            <p className="Indented">Smatramo da je dobro poznavanje standardnih industrijskih procesa izuzetno korisno
                po proces razvoja informacijskih sustava u toj konkretnoj industriji. Takvo poznavanje procesa omogućava kvalitetnija
                rješenja, kao i skraćivanje vremena potrebnog za razvoj. No, nikako se ne treba zanemariti uloga i efekt
                preporuke promjene poslovnih procesa radi usklađivanja s najboljim praksama u industriji.
                U Novoj Inteligenciji imamo iskustva u nekoliko industrija.
            </p><br/>
            <p className="NonIndented"><b>Financijska industrija</b> - U financijskoj industriji naglasak stavljamo na 
                našu ekspertizu u svekanalnoj integraciji (<i>Omnichannel</i>) koja omogućava klijentima ujednačeno iskustvo 
                u web i mobilnom pristupu uslugama financijske institucije. Uz to, imamo znanja o procesima platnog prometa,
                financiranja (kreditiranja), te općenito o računovodstvenim postupcima u bankarskim institucijama.
            </p>
            <p className="NonIndented"><b>Telekomunikacije</b> - Uz općenito poznavanje telekomunikacijskih standarda poput 
                SID-a (<i>TM forum information framework</i>) i eTOM-a (TM forum business process framework), imamo značajnog 
                iskustva u više područja:
                <ul>
                    <li>BSS - Obračun troškova i tarife (<i>charging</i>), to jest sustavi za praćenje potrošnje korisnika,
                        te naplata i izdavanje računa (<i>billing</i>).</li>
                    <li>Uspostava kataloga produkata temeljenog na SID modelu. Takav se katalog produkata zatim koristi 
                        za povezivanje BSS-a i OSS-a u procesima realizacije narudžbi (<i>order fulfillment</i>).</li>
                    <li>Stvaranje narudžbi prema SID temeljenom katalogu produkata, pritom pazeći da se narudžba Kasnije
                        može realizirati kroz BSS-OSS sučelje.</li>
                    <li>Deklarativna pravila za realizaciju narudžbi kroz BSS-OSS sučelje, uzimajući definicija iz 
                        SID temeljenog produktnog kataloga.</li>
                </ul>
            </p>
            <p className="NonIndented"><b>Aeronautika (avijacija)</b> - Uz općenito poznavanje poslovnih procesa u avijaciji,
                napose kontroli zračne plovidbe, posebni fokus pridajemo upravljanju tokova zračnog prometa 
                (<i>FMP - Flow Management Position</i>):
                <ul>
                    <li>Poznavanje strukture zračnog prostora i stvaranje konfiguracija zračnog prostora</li>
                    <li>Aktivacije konfiguracija u zračnom prostoru</li>
                    <li>Mjere za regulaciju zračnog prometa</li>
                    <li>Rute letova, vizualizacije u GIS alatima</li>
                    <li>Analiza i statistika zračnog prometa</li>
                    <li>NM B2B</li>
                </ul>
            </p>
            <p className="NonIndented"><b>Porezna uprava</b> - Ekspertiza uključuje sustave za komunikaciju podataka 
                između država EU, poput VIES-a, VAT Refund-a, VoeS-a, DAC i FATCA sustava.
            </p>
        </>
    );
}